import React, { useMemo } from "react";
import { Link, useHistory } from "react-router-dom";

import { Box, Typography } from "@material-ui/core";
import ContentAdd from "@material-ui/icons/Add";

import {
  Button,
  // CreateButton
} from "react-admin";
import { useTranslate } from "ra-core";

import { isSubscriptionDisabled } from "../../utils/appUtils";

export const Empty = ({
  basePath,
  resource,
  message,
  backPath,
  state,
  hasCreate = true,
  ...props
}) => {
  return (
    <Box textAlign="center" m={1}>
      <Typography variant="body1" gutterBottom>
        {message}
      </Typography>
      {hasCreate && (
        <CreateButton
          {...props}
          basePath={basePath}
          resource={resource}
          backPath={backPath}
          state={state}
          disabled={isSubscriptionDisabled()}
        />
      )}
    </Box>
  );
};

const CreateButton = (props) => {
  const {
    basePath = "",
    resource,
    backPath,
    state = {},
    className,
    label = "ra.action.create",
    scrollToTop = true,
    variant,
    ...rest
  } = props;
  const history = useHistory();
  const translate = useTranslate();

  const location = useMemo(
    () => ({
      pathname: basePath ? `${basePath}/create` : `/${resource}/create`,
      state: {
        ...state,
        backPath: backPath
          ? [...backPath, history.location.pathname]
          : [history.location.pathname],
        _scrollToTop: scrollToTop,
      },
    }),
    [basePath, resource, backPath, state, history, scrollToTop],
  );

  return (
    <Button
      component={Link}
      to={location}
      className={className}
      label={translate(label)}
      variant={variant}
      {...rest}
    >
      <ContentAdd />
    </Button>
  );
};
